import { FC, PropsWithChildren } from "react";

export const AssetLabel: FC<
  PropsWithChildren<{
    asset?:
      | { metadata: { symbol: string }; type: string; chain: string }
      | null
      | undefined;
    Container: FC<PropsWithChildren>;
  }>
> = ({ asset, Container }) =>
  asset ? (
    <>
      {asset.metadata.symbol}
      {((asset.metadata.symbol === "USDT" && asset.chain !== "ETH") ||
        (asset.metadata.symbol === "ETH" && asset.chain !== "ETH") ||
        (asset.metadata.symbol === "USDC" && asset.chain !== "ETH")) &&
        asset.type === "SECURED" && <Container>.{asset.chain}</Container>}
    </>
  ) : null;
